module.exports = __webpack_public_path__ + "img/16.7dc31c4a.jpg";